import { useEffect, useRef, useState } from 'react';

export default function Testimonial() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const testimonials = [
    {
      name: "김**",
      role: "IT 개발자",
      content:
        "유튜브 영상과 핵심 표현을 함께 제공해줘서 출퇴근 시간에 부담없이 학습할 수 있어요. 3개월 만에 JLPT N2를 합격했습니다.",
      rating: 5,
    },
    {
      name: "박**",
      role: "사업가",
      content: `일본에서 대학 나오고 상사까지 다녔지만,
독립해 일본 시장에 진출하니 말 하나에 오해가 생기고, 벽이 느껴졌습니다.
LEXO Biz는 '직장 일본어'가 아닌, '대표의 언어'를 훈련해줍니다.`,
      rating: 5,
    },
    {
      name: "이**",
      role: "대학생",
      content:
        "Black 플랜으로 시작한 후 일본인 여자친구와의 소통이 정말 원활해졌어요. 실생활에서 바로 쓸 수 있는 표현들을 배워서 관계가 더 깊어졌습니다.",
      rating: 5,
    },
  ];

  return (
    <section ref={sectionRef} className="py-16 sm:py-24 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div
          className={`text-center mb-12 sm:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="inline-block px-4 sm:px-5 py-2 bg-[#14B8A6]/10 border border-[#14B8A6]/30 rounded-full mb-4 sm:mb-6">
            <span className="text-[13px] sm:text-[14px] font-medium text-[#14B8A6]">
              학습자 후기
            </span>
          </div>
          <h2 className="text-[36px] sm:text-[48px] lg:text-[56px] font-bold text-white mb-4 sm:mb-6 leading-tight px-4">
            실제 학습자들의<br />
            생생한 경험
          </h2>
          <p className="text-[15px] sm:text-[17px] text-gray-400 max-w-2xl mx-auto leading-relaxed px-4">
            LEXO와 함께 일본어 실력을 향상시킨<br />
            학습자들의 이야기를 들어보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-[#1A1A1A] border border-gray-800 rounded-2xl p-6 sm:p-8 hover:border-[#14B8A6]/50 transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
              }`}
              style={{ transitionDelay: `${200 + index * 200}ms` }}
            >
              <div className="flex gap-1 mb-5 sm:mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-[16px] sm:text-[18px] text-[#14B8A6]"
                  ></i>
                ))}
              </div>

              <p className="text-[14px] sm:text-[15px] text-gray-300 leading-relaxed mb-6 sm:mb-8">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3 sm:gap-4 pt-5 sm:pt-6 border-t border-gray-800">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden flex-shrink-0 bg-[#14B8A6] flex items-center justify-center">
                  <span className="text-[10px] sm:text-[11px] font-bold text-white tracking-tight">LEXO</span>
                </div>
                <div>
                  <p className="text-[15px] sm:text-[16px] font-semibold text-white">
                    {testimonial.name}
                  </p>
                  <p className="text-[13px] sm:text-[14px] text-gray-500">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}